/**
 * S14/S15 export/import-flow dialogs, mounted once per dashboard tab
 * (outside the kebab): the id-conflict "import as copy" confirm, the
 * missing-connection remap dialog, and the S15 "Export as HTML…" options
 * dialog. All state comes from `useDashboardExportFlow`.
 */
import { ConfirmDialog } from '@/components/ui/ConfirmDialog';
import { useConnectionStore } from '@/features/connections/store/connectionStore';
import { HtmlSnapshotExportDialog } from './HtmlSnapshotExportDialog';
import { ImportRemapDialog } from './ImportRemapDialog';
import type { DashboardExportFlow } from './useDashboardExportFlow';

export function DashboardExportDialogs({ flow }: { flow: DashboardExportFlow }) {
  const connections = useConnectionStore((s) => s.connections);
  return (
    <>
      <ConfirmDialog
        open={flow.conflict !== null}
        onOpenChange={(open) => !open && flow.cancelConflict()}
        title="Dashboard already exists"
        description={
          flow.conflict
            ? `A dashboard with the id of “${flow.conflict.name}” is already on this machine. Import it as a copy with a new id?`
            : undefined
        }
        confirmLabel="Import as copy"
        onConfirm={flow.confirmImportAsCopy}
      />
      {flow.remap && (
        <ImportRemapDialog
          open
          onOpenChange={(open) => !open && flow.closeRemap()}
          dashboardName={flow.remap.dashboard.name}
          refs={flow.remap.refs}
          connections={connections}
          onApply={flow.applyRemap}
        />
      )}
      <HtmlSnapshotExportDialog
        open={flow.htmlSnapshotDialogOpen}
        onOpenChange={flow.setHtmlSnapshotDialogOpen}
        onConfirm={flow.confirmExportHtmlSnapshot}
      />
    </>
  );
}
